import React from "react";
import { BiTrash } from "react-icons/bi";

function Task(
  {
    task,
    checkTask,
    deleteTask,
    updateTask,
    dndProps,
    dndDragHandleProps,
    ...rest
  },
  ref
) {
  const [checked, setChecked] = React.useState(task.checked);

  const [editing, setEditing] = React.useState(false);
  const [newLabel, setNewLabel] = React.useState(task.label);

  React.useEffect(() => {
    setChecked(task.checked);
  }, [task]);

  React.useEffect(() => {
    setNewLabel(task.label);
  }, [task]);

  function toggleEditing() {
    if (editing === false) {
      setEditing(true);
    } else {
      updateTask(task, newLabel);
      setEditing(false);
    }
  }

  function getTaskDate() {
    if (task.checkedDate === undefined) {
      return;
    }

    const timeStamp = task.checkedDate;
    const date = new Date(timeStamp);
    const dateFormat =
      date.toDateString() + "," + date.getHours() + ":" + date.getMinutes();

    return dateFormat;
  }

  getTaskDate();

  return (
    <li
      ref={ref}
      className="group flex items-center gap-3 rounded-lg py-2 px-4 transition-colors duration-100 ease-in-out focus-within:bg-slate-100 focus-within:drop-shadow-lg hover:bg-slate-100 dark:focus-within:bg-zinc-700  dark:hover:bg-zinc-700/50"
      {...dndProps}
      {...dndDragHandleProps}
      {...rest}
    >
      <div className="flex grow items-center gap-3">
        <input
          className="border-1 scale-150 cursor-pointer rounded-md border-gray-200 focus:border-none  focus:outline-none focus:ring-0  focus:ring-offset-0 dark:border-zinc-500 dark:bg-zinc-600"
          type="checkbox"
          id="task-checkbox"
          checked={checked}
          onChange={(event) => {
            setChecked(!checked);
            checkTask(task);
          }}
        />

        {editing === false ? (
          <p
            className={checked ? "line-through opacity-30" : "cursor-default"}
            onClick={toggleEditing}
          >
            {task.label}
          </p>
        ) : (
          <form
            onSubmit={toggleEditing}
            onBlur={toggleEditing}
            className="w-full"
          >
            <input
              className="w-full border-none bg-transparent "
              type="text"
              autoFocus
              value={newLabel}
              onChange={(event) => {
                setNewLabel(event.target.value);
              }}
            />
          </form>
        )}
      </div>

      {/* Delete */}
      <button
        type="button"
        className="transform opacity-0 duration-300 ease-in-out group-hover:opacity-100"
        onClick={() => {
          if (
            window.confirm(`Do you actually want to delete "${task.label}"`)
          ) {
            deleteTask(task);
          }
        }}
      >
        <BiTrash className="scale-125 opacity-40" />
      </button>

      {/* Date */}
      {task.checked && (
        <span className="text-xs text-slate-300">{getTaskDate()}</span>
      )}
    </li>
  );
}

export default React.forwardRef(Task);
